import React, { Component } from 'react';
import { SERVER_URL } from './ServerConfig'
import { Modal, Button } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';

class RemenerationList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            remunerationList: [],

            pendingAddRemuneration: false,
            addPrice: "",
            addFrom: "",
            addTo: "",
            addRemunerationMessage: "",

            editRemuneration: null,
            pendingEditRemuneration: false,
            editPrice: "",
            editFrom: "",
            editTo: "",
            editRemunerationMessage: "",

            pendingDeleteRemuneration: false,
            deleteRemuneration: null,
            deleteRemunerationMessage: "",
            deletePrice: "",
            deleteFrom: "",
            deleteTo: "",
        }

        this.handleOpenAddRemuneration = this.handleOpenAddRemuneration.bind(this);
        this.handleCloseAddRemuneration = this.handleCloseAddRemuneration.bind(this);
        this.handleAddPrice = this.handleAddPrice.bind(this);
        this.handleAddFrom = this.handleAddFrom.bind(this);
        this.handleAddTo = this.handleAddTo.bind(this);
        this.handleSaveRemuneration = this.handleSaveRemuneration.bind(this);

        this.handleOpenEditRemuneration = this.handleOpenEditRemuneration.bind(this);
        this.handleCloseEditRemuneration = this.handleCloseEditRemuneration.bind(this);
        this.handleEditPrice = this.handleEditPrice.bind(this);
        this.handleEditFrom = this.handleEditFrom.bind(this);
        this.handleEditTo = this.handleEditTo.bind(this);
        this.handleSaveEditRemuneration = this.handleSaveEditRemuneration.bind(this);

        this.handleOpenDeleteRemuneration = this.handleOpenDeleteRemuneration.bind(this);
        this.handleCloseDeleteRemuneration = this.handleCloseDeleteRemuneration.bind(this);
        this.handleSaveDeleteRemuneration = this.handleSaveDeleteRemuneration.bind(this);
    }

    notifyAdded = () => {
        toast.success("New remuneration has been added!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    notifyUpdated = () => {
        toast.success("Remuneration has been updated successfully!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    notifyDeleleted = () => {
        toast.success("Remuneration has been deleted successfully!", {
            position: toast.POSITION.TOP_CENTER
        });
    };

    isOwner() {
        let user = this.props.user.payload.user;
        return user.member.mRole === 'owner';
    }

    formatDate(date) {
        return moment(date).format('YYYY-DD-MM');
    }

    toISODate(date) {
        return moment(date).toISOString();
    }

    componentDidMount() {
        this.fetchRemunerationList();
    }

    fetchRemunerationList() {
        let station = this.props.station;
        if (!station) {
            return;
        }
        let stationId = station._id;

        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        fetch(SERVER_URL + '/v1/stations/' + stationId + '/getPriceHistory', {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        }).then(data => {
            if (data.success) {
                let remunerationList = data.content;
                this.setState({ isLoading: false, remunerationList: remunerationList });
            }
        });
    }

    handleOpenAddRemuneration(event) {
        let station = this.props.station;
        this.setState({ pendingAddRemuneration: true, addPrice: station.mRemuneration, addFrom: "", addTo: "" });
    }

    handleAddPrice(event) {
        this.setState({ addPrice: event.target.value });
    }

    handleAddFrom(date) {
        this.setState({ addFrom: date });
    }

    handleAddTo(date) {
        this.setState({ addTo: date });
    }

    handleCloseAddRemuneration() {
        this.setState({ pendingAddRemuneration: false, addPrice: "", addFrom: "", addTo: "" });
    }

    handleSaveRemuneration() {
        if (this.canAddRemunerationClass() === "disabled") {
            return;
        }
        let body = {
            remuneration: this.state.addPrice,
            start: this.toISODate(this.state.addFrom),
            end: this.toISODate(this.state.addTo)
        }

        let station = this.props.station;
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;

        fetch(SERVER_URL + '/v1/stations/' + station._id + '/addPriceHistory', {
            method: 'post',
            headers: {
                'x-access-token': token,
                'content-type': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    this.handleCloseAddRemuneration();
                    this.fetchRemunerationList();
                    this.notifyAdded();
                } else {
                    this.setState({ addRemunerationMessage: data.message });
                }
            })
    }

    canAddRemunerationClass() {
        if (!this.state.addPrice || !this.state.addFrom || !this.state.addTo) {
            return "disabled";
        }
        return "";
    }

    getAddRemunerationModal() {
        return (
            <Modal show={this.state.pendingAddRemuneration} onHide={this.handleCloseAddRemuneration} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Add remuneration history</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" >
                        <div className="text-center">
                            <p className="text-danger">{this.state.addRemunerationMessage}</p>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Price per kWh</label>
                            <div className="col-sm-8">
                                <input input type="number" min="0" className="form-control" placeholder="" value={this.state.addPrice} onChange={this.handleAddPrice} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">From</label>
                            <div className="col-sm-8">
                                <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.addFrom}
                                    className="day-picker-input form-control form-control-sm"
                                    onChange={date => this.handleAddFrom(date)} todayButton="Today" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">To</label>
                            <div className="col-sm-8">
                                <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.addTo} showDisabledMonthNavigation minDate={this.state.addFrom}
                                    className="day-picker-input form-control form-control-sm"
                                    onChange={date => this.handleAddTo(date)} todayButton="Today" />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseAddRemuneration}>
                        Close
                        </Button>
                    <Button variant="success" onClick={this.handleSaveRemuneration} className={this.canAddRemunerationClass()}>
                        Add
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleOpenEditRemuneration(event, item) {
        let start = (item.mStart) ? moment(item.mStart).toDate() : new Date();
        let end = (item.mEnd) ? moment(item.mEnd).toDate() : new Date();
        this.setState({ pendingEditRemuneration: true, editPrice: item.mRemuneration, editFrom: start, editTo: end, editRemuneration: item });
    }

    handleEditPrice(event) {
        this.setState({ editPrice: event.target.value });
    }

    handleEditFrom(date) {
        this.setState({ editFrom: date });
    }

    handleEditTo(date) {
        this.setState({ editTo: date });
    }

    handleCloseEditRemuneration() {
        this.setState({ pendingEditRemuneration: false, editPrice: "", editFrom: "", editTo: "", editRemuneration: null });
    }

    handleSaveEditRemuneration() {
        if (this.canEditRemunerationClass() === "disabled") {
            return;
        }
        let body = {
            priceHistoryId: this.state.editRemuneration._id,
            remuneration: this.state.editPrice,
            start: this.toISODate(this.state.editFrom),
            end: this.toISODate(this.state.editTo)
        }

        let station = this.props.station;
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;

        fetch(SERVER_URL + '/v1/stations/' + station._id + '/updatePriceHistory', {
            method: 'post',
            headers: {
                'x-access-token': token,
                'content-type': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    this.handleCloseEditRemuneration();
                    this.fetchRemunerationList();
                    this.notifyUpdated();
                } else {
                    this.setState({ addRemunerationMessage: data.message });
                }
            })
    }

    canEditRemunerationClass() {
        if (!this.state.editPrice || !this.state.editFrom || !this.state.editTo) {
            return "disabled";
        }
        let item = this.state.editRemuneration;
        let start = (item.mStart) ? moment(item.mStart).toDate() : new Date();
        let end = (item.mEnd) ? moment(item.mEnd).toDate() : new Date();
        if (this.state.editPrice === item.mRemuneration && this.formatDate(this.state.editFrom) === this.formatDate(start)
            && this.formatDate(this.state.editTo) === this.formatDate(end)) {
            return "disabled";
        }
        return "";
    }

    getEditRemunerationModal() {
        return (
            <Modal show={this.state.pendingEditRemuneration} onHide={this.handleCloseEditRemuneration} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Edit remuneration history</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-horizontal" >
                        <div className="text-center">
                            <p className="text-danger">{this.state.editRemunerationMessage}</p>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Price per kWh</label>
                            <div className="col-sm-8">
                                <input input type="number" min="0" className="form-control" placeholder="" value={this.state.editPrice} onChange={this.handleEditPrice} />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">From</label>
                            <div className="col-sm-8">
                                <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.editFrom}
                                    className="day-picker-input form-control form-control-sm"
                                    onChange={date => this.handleEditFrom(date)} todayButton="Today" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label">To</label>
                            <div className="col-sm-8">
                                <DatePicker dateFormat="dd/MM/yyyy" selected={this.state.editTo} showDisabledMonthNavigation minDate={this.state.editFrom}
                                    className="day-picker-input form-control form-control-sm"
                                    onChange={date => this.handleEditTo(date)} todayButton="Today" />
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseEditRemuneration}>
                        Close
                        </Button>
                    <Button variant="success" onClick={this.handleSaveEditRemuneration} className={this.canEditRemunerationClass()}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleOpenDeleteRemuneration(event, item) {
        let start = (item.mStart) ? this.formatDate(item.mStart) : this.formatDate(new Date());
        let end = (item.mEnd) ?  this.formatDate(item.mEnd) : this.formatDate(new Date());
        this.setState({ pendingDeleteRemuneration: true, deleteRemuneration: item, deletePrice : item.mRemuneration, deleteFrom : start, deleteTo : end });
    }

    handleCloseDeleteRemuneration(event) {
        this.setState({ pendingDeleteRemuneration: false, deleteRemuneration: null, deletePrice : "", deleteFrom : "", deleteTo : ""  });
    }

    handleSaveDeleteRemuneration(event) {
        let body = {
            priceHistoryId: this.state.deleteRemuneration._id
        }

        let station = this.props.station;
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;

        fetch(SERVER_URL + '/v1/stations/' + station._id + '/deletePriceHistory', {
            method: 'delete',
            headers: {
                'x-access-token': token,
                'content-type': 'application/json'
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data.success) {
                    this.handleCloseDeleteRemuneration();
                    this.fetchRemunerationList();
                    this.notifyDeleleted();
                } else {
                    this.setState({ deleteRemunerationMessage: data.message });
                }
            })
    }

    getDeleteRemunerationModal() {
        return (
            <Modal show={this.state.pendingDeleteRemuneration} onHide={this.handleCloseDeleteRemuneration} animation={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Delete remuneration</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {"Do you want to delete this remuneration?"}                    
                    <div className="text-center">
                        <p className="text-danger">{this.state.deleteRemunerationMessage}</p>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">Price per kWh</label>
                        <div className="col-sm-8 d-flex align-items-center">
                            <div>{this.state.deletePrice}</div>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">From</label>
                        <div className="col-sm-8 d-flex align-items-center">
                            <div>{this.state.deleteFrom}</div>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label">To</label>
                        <div className="col-sm-8 d-flex align-items-center">
                            <div>{this.state.deleteTo}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="default" onClick={this.handleCloseDeleteRemuneration}>
                        No
                        </Button>
                    <Button variant="danger" onClick={this.handleSaveDeleteRemuneration}>
                        Yes
                        </Button>
                </Modal.Footer>
            </Modal>
        );
    }


    getButtonBar() {
        if (this.isOwner()) {
            return (
                <div className="row d-flex justify-content-end mr-1">
                    <div>
                        <button type="button" className="btn btn-block btn-success btn-md" onClick={this.handleOpenAddRemuneration}>Add</button>
                    </div>
                </div>)
        }
        return (
            <div></div>
        );
    }

    getActionColumnDetails(item) {
        if (this.isOwner()) {
            return (
                <td style={{ width: '50px' }}>
                    <div className="btn-group btn-group-md">
                        <a href="#" className="btn btn-info" onClick={e => this.handleOpenEditRemuneration(e, item)}><i className="fas fa-edit"></i></a>
                        <a href="#" className="btn btn-danger" onClick={e => this.handleOpenDeleteRemuneration(e, item)}><i className="fas fa-trash"></i></a>
                    </div>
                </td>
            )
        }
    }

    getItems(item, idx) {
        return (
            <tr key={item._id}>
                <td scope="row">
                    {idx + 1}
                </td>
                <td>{item.mRemuneration}</td>
                <td>{this.formatDate(item.mStart)}</td>
                <td>{this.formatDate(item.mEnd)}</td>
                {this.getActionColumnDetails(item)}
            </tr>
        );
    }

    getBody(remunerationList) {
        return remunerationList.map((item, idx) => {
            return this.getItems(item, idx);
        })
    }

    getEditRemunerationColumnHeader() {
        if (this.isOwner()) {
            return (
                <th scope="col"></th>
            )
        }
    }

    render() {
        if (this.state.isLoading) {
            return (
                <div></div>
            )
        }
        let remunerationList = this.state.remunerationList;
        return (
            <div>
                <div className="d-flex justify-content-between">
                    <label htmlFor="inputName2" className="col-form-label">Remuneration per kWh List</label>
                    {this.getButtonBar()}
                </div>
                <section className="content">
                    <div>
                        <div className="table-responsive mt-4">
                            <table className="table table-bordered table-hover dataTable" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Price</th>
                                        <th scope="col">From</th>
                                        <th scope="col">To</th>
                                        {this.getEditRemunerationColumnHeader()}
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.getBody(remunerationList)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </section>
                {this.getAddRemunerationModal()}
                {this.getEditRemunerationModal()}
                {this.getDeleteRemunerationModal()}
            </div>
        )
    }
}


export default RemenerationList;